// Single shared hook that reads the platform-wide Silo Wars master
// toggle. Any battles UI element checks this and hides itself when off.
//
// Cached for 60s so we don't spam /api/platform-flags on every render.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = { value: null, fetched_at: 0 };
const CACHE_MS = 60_000;

export function useBattlesEnabled() {
  const [enabled, setEnabled] = useState(_cache.value);
  const [loading, setLoading] = useState(_cache.value === null);

  useEffect(() => {
    let cancel = false;
    const now = Date.now();
    if (_cache.value !== null && now - _cache.fetched_at < CACHE_MS) {
      setEnabled(_cache.value);
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const r = await api.get("/platform-flags");
        const v = !!r.data?.battles_enabled;
        _cache = { value: v, fetched_at: Date.now() };
        if (!cancel) { setEnabled(v); setLoading(false); }
      } catch {
        _cache = { value: false, fetched_at: Date.now() };
        if (!cancel) { setEnabled(false); setLoading(false); }
      }
    })();
    return () => { cancel = true; };
  }, []);

  return { enabled, loading };
}

// Imperative invalidator — call after the super admin flips the toggle
// so the next page that reads this hook sees the new value immediately.
export function invalidateBattlesEnabled() {
  _cache = { value: null, fetched_at: 0 };
}
